import React from 'react';
import { Container, Card, CardBody, Button, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faHeart, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import policy from '../../assets/WelfareSchemes/above 60 years policy complete.pdf'
import policy1 from '../../assets/WelfareSchemes/Blind ESM Policy Completed.pdf'
import policy2 from '../../assets/WelfareSchemes/blind policy completed.pdf'
import policy3 from '../../assets/WelfareSchemes/Defence 2 Schemes.pdf'
import policy4 from '../../assets/WelfareSchemes/Disabled policy completed.pdf'
import policy5 from '../../assets/WelfareSchemes/ESM above 60 years policy Completed.pdf'
import policy6 from '../../assets/WelfareSchemes/FA to blind.pdf'
import policy7 from '../../assets/WelfareSchemes/Fa to Disable ESM.pdf'
import policy8 from '../../assets/WelfareSchemes/FA to ESM (above 60 yrs) and their widows.pdf'
import policy9 from '../../assets/WelfareSchemes/FA to orphan.pdf'
import policy10 from '../../assets/WelfareSchemes/Fa to Para Tetra plegic.pdf'
import policy11 from '../../assets/WelfareSchemes/FA to War widows.pdf'
import policy12 from '../../assets/WelfareSchemes/FA to WW II.pdf'
import policy13 from '../../assets/WelfareSchemes/orphan policy complete.pdf'
import policy14 from '../../assets/WelfareSchemes/pera tetra hemi plagic policy completed.pdf'
import policy15 from '../../assets/WelfareSchemes/Widow of WWII policy Completed.pdf'
import policy16 from '../../assets/WelfareSchemes/Widows of ESM policy completed.pdf'

const WelfareScheme = () => {
  const data = [
    { name: 'Additional Pension-Disabled ESM having children', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=hM5OQxY5WVYrlVUPtSt+Vw==' ,policy: policy},
    { name: 'Additional Pension-Disabled ESM having no child', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=7kDaGn2G0FAwOp1V/f8Jxg==' ,policy: policy1},
    { name: 'Additional Pension-JCO', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=CWtwrLuSHA+MrAz+q3HbJw==' ,policy: policy2},
    { name: 'Additional Pension-Officers', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=OjsERHFMInpPkN5mRjzBvg==' ,policy: policy3},
    { name: 'Additional Pension-Other Ranks', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=WUxwfvzMQcQ/CxGCjAmbjA==' ,policy: policy4},
    { name: 'Additional Pension-Widows having child', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=mgAgyHt+yeSjIB09oHPheA==' ,policy: policy5},
    { name: 'Additional Pension-Widows having no child', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=cXdgTRUHEKzvcHb09M5Ylg==' ,policy: policy6},
    { name: 'Disabled Ex Gratia Grant of Defence Forces According to the percentage of Disability', link: 'https://kms.saralharyana.nic.in/ViewDoc?Id=eI3amz/RZG99NHpizgfuSg==' ,policy: policy7},
    { name: 'Disabled Ex Gratia Grant of Para Military Forces According to the percentage of Disability', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=/H432+LFd6Eqn6JlERnhTQ==' ,policy: policy8},
    { name: 'Financial Assistance of Orphan Children of ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=eyROwv6gwnsvupa++ExhNw==' ,policy: policy9},
    { name: 'Financial Assistance to blind ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=wIdgeEWtdnbpGpraWgQz1g==' ,policy: policy10},
    { name: 'Financial Assistance to Disabled ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=SyeR+a9xUnmZwSqp+PSElQ==' ,policy: policy11},
    { name: 'Financial Assistance to Ex Servicemen of and above the age of 60', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=ShQw/AgGJ+0ZDJB5Lm/27w==' ,policy: policy12},
    { name: 'Financial Assistance to Para Tetra Plegic ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=Ha6R+2zkDjDf+slCpPJPSQ==' ,policy: policy13},
    { name: 'Financial Assistance to war widows of Defence Forces', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=RMrBNRfJbVTRKZ9wsr54YA==' ,policy: policy14},
    { name: 'Financial Assistance to Widow WW-II', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=jZ850AqHSmXIbOHpqhpegQ==' ,policy: policy15},
    { name: 'Financial Assistance to widows of Ex Servicemen of and above the age of 60', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=i8NlVQyL0nxaAqIoS5CoMA==' ,policy: policy16},
    { name: 'Financial Assistance to WW-II Veteran', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=LAhg8Ule8M0H9QpdT6LMFQ==' ,policy: policy},
    { name: 'Marriage Grant-Orphan Daughter ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=5rjEKrm37i3Fi7C4ijB56w==' ,policy: policy},
    { name: 'Marriage Grant-War Disabled ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=rEiIiJLpvwS6fM6e7MBBzw==' ,policy: policy},
    { name: 'Marriage Grant-War Widow ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=xx1ENHZtUjctalsqq4+Oew==' ,policy: policy},
    { name: 'Marriage Grant-Widow ESM', link: 'https://kms.saralharyana.nic.in/ViewDoc.aspx?Id=MciCAGC0ON6C0+2LU31oxg==' ,policy: policy}
  ];

  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faHeart} className="me-2" />
            Welfare Schemes
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faHeart} className="me-2" />
              Available Welfare Schemes
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="table-responsive">
              <Table bordered hover className="mb-0">
                <thead>
                  <tr>
                    <th style={{ background: '#1e3c72', color: 'white', width: '10%' }}>Sr. No.</th>
                    <th style={{ background: '#1e3c72', color: 'white', width: '50%' }}>Name of Scheme</th>
                    <th style={{ background: '#16a085', color: 'white', width: '20%' }}>Document</th>
                    <th style={{ background: '#8e44ad', color: 'white', width: '20%' }}>Policy</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td style={{ color: '#495057' }}>{index + 1}</td>
                      <td style={{ color: '#1e3c72', fontWeight: '600' }}>{item.name}</td>
                      <td className="text-center">
                        <Link 
                          to={item.link} 
                          target="_blank" 
                          style={{
                            color: '#dc3545',
                            textDecoration: 'none',
                            fontSize: '24px',
                            transition: 'all 0.3s'
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = '#1e3c72';
                            e.currentTarget.style.transform = 'scale(1.2)';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = '#dc3545';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        >
                          <FontAwesomeIcon icon={faFilePdf} />
                        </Link>
                      </td>
                      <td className="text-center">
                        <a 
                          href={item.policy} 
                          rel="noopener noreferrer" 
                          target="_blank" 
                          style={{
                            color: '#dc3545',
                            textDecoration: 'none',
                            fontSize: '24px',
                            transition: 'all 0.3s'
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.color = '#1e3c72';
                            e.currentTarget.style.transform = 'scale(1.2)';
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.color = '#dc3545';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        >
                          <FontAwesomeIcon icon={faFilePdf} />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>

        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
              Apply for Welfare Schemes
            </h4>
          </div>
          <CardBody className="p-5 text-center">
            <p className="mb-4" style={{ color: '#495057', fontSize: '1.1rem' }}>
              Click below to apply for welfare schemes through the official portal
            </p>
            <Button
              style={{
                background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                border: 'none',
                borderRadius: '20px',
                padding: '12px 40px',
                fontWeight: '600',
                fontSize: '1rem'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
              <Link 
                to="https://saralharyana.gov.in/" 
                target="_blank" 
                style={{ 
                  color: 'white', 
                  textDecoration: 'none'
                }}
              >
                Click Here
              </Link>
            </Button>
          </CardBody>
        </Card>
      </Container>
    </>
  )
}

export default WelfareScheme